import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class TokenTransactions extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default TokenTransactions
